// @ts-nocheck
import { get, post } from './utils/api/base';
const API_URL = process.env.REACT_APP_BASE_API_URL || 'http://localhost:3500';
/**
 * ============================
 *       TIPAGENS ANEXOS
 * ============================
 */
/**
 * @typedef {Object} AnexoDepot
 * @property {number} [Id]
 * @property {number} [id]
 * @property {string} [NomeOriginal]
 * @property {string} [nomeOriginal]
 * @property {string} [UrlArquivo]
 * @property {string} [urlArquivo]
 * @property {number} [Tamanho]
 * @property {number} [tamanho]
 * @property {string} [DataCriacao]
 * @property {string} [dataCriacao]
 * @property {number} [DepotId]
 * @property {number} [depotId]
 * @property {{ NumeroContainer?: string }} [Depot]
 */
/**
 * Filtros da listagem de Anexos de Depots.
 *
 * @typedef {Object} AnexosDepotFilters
 * @property {string} [NomeOriginal]
 * @property {string} [NumeroContainer]
 * @property {number|string} [DepotId]
 * @property {string} [DataCriacaoInicio]
 * @property {string} [DataCriacaoFim]
 * @property {number|string} [page]
 * @property {number|string} [limit]
 * @property {number|string} [pagina]
 * @property {number|string} [quantidadePorPagina]
 * @property {string} [OrdenarPor]
 * @property {string} [Direcao]
 */
/**
 * @typedef {Object} AnexosDepotsResponse
 * @property {AnexoDepot[]} [registros]
 * @property {number} [totalRegistros]
 * @property {number} [paginaAtual]
 * @property {number} [quantidadePorPagina]
 */
/**
 * @typedef {Object} DownloadAnexosZipPayload
 * @property {number[]} ids
 */
const toQueryString = (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    return queryParams.toString();
};
/**
 * Lista anexos de depots com filtros e paginação.
 * @param {AnexosDepotFilters} [filters={}] Filtros para busca.
 * @returns {Promise<AnexosDepotsResponse>} Resposta com registros paginados.
 */
export const getAnexosDepots = async (filters = {}) => {
    const query = toQueryString(filters);
    const url = `${API_URL}/depots/anexos${query ? `?${query}` : ''}`;
    const response = await get(url);
    return response?.data || response || {};
};
/**
 * Baixa um arquivo ZIP contendo os anexos selecionados.
 * @param {number[]} [ids=[]] IDs dos anexos.
 * @returns {Promise<Blob|Object>} Arquivo de download.
 */
export const downloadAnexosDepotsZip = async (ids = []) => {
    /** @type {DownloadAnexosZipPayload} */
    const payload = { ids: Array.isArray(ids) ? ids : [] };
    const response = await post(`${API_URL}/depots/anexos/download`, payload, {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return response?.data || response;
};
